<script>
  import { onMount, afterUpdate } from 'svelte';
  import LogMessageJSON from './LogMessageJSON.svelte'
  import parseInlineJSON from './extract-json.js';

  export let msg;
  export let expand = 0;

  const isString = v => 
    (typeof v === 'string' || v instanceof String);

  $: parts = parseInlineJSON(msg);
</script>

{#each parts as x, i}
  {#if isString(x)}
    <div>{x}</div>
  {:else}
    <LogMessageJSON {expand} obj={x} />
  {/if}
{/each}

<style>
  div {
    padding-right: 0.25rem;
  }
</style>
